export function treatApiError(res) {
  if (typeof res.message?.error === 'string') {
    throw new Error(res.message.error);
  }
  throw new Error(res.message.error.message);
}
